import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Container, Image } from "react-bootstrap";
import "./index.css";
import "./userCompanyInfo.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import isEmpty from "../../../../utils/is-Empty";
import { capitalize } from "lodash";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import { getUserFactoryInfo, postUserFactoryInfo } from "../../../../actions/user.actions";
import TimestampConverter from "../../../../utils/TimestampConverter";
import PageSpinner from "../../../common/PageSpinner";
import { useDialog } from "../../../../helpers/useDialog";
import { toast } from "react-toastify";

const UserFactoryInfo = ({ title = "Factory Info", userId, userObj }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [factoryInfo, setFactoryInfo] = useState({});
  const { requestCall } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    callGetUserFactoryInfoAPI(userId, dispatch);
  }, [dispatch, userId]);

  useEffect(() => {
    setIsCreateMode(false);
    setIsUpdateMode(false);
    if (!isEmpty(factoryInfo?.data)) {
      setUploadFormObj(factoryInfo?.data);
    } else {
      setIsCreateMode(true);
    }
  }, [factoryInfo]);

  const callGetUserFactoryInfoAPI = (mUserId, dispatch) => {
    setLoading(true);
    getUserFactoryInfo(mUserId, dispatch)
      .then((res) => {
        setFactoryInfo(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSelectValue = (key, value) => {
    // console.log("*** change ", key, value)
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousVlaues) => ({
      ...previousVlaues,
      ...updatedObj,
    }));
  };

  const handleBISFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMsg("❌ BIS CML file size must be ≤ 2MB");
      return;
    }
    onSelectValue("bis_cml_doc", selectedFile);
    setErrorMsg("");
  };

  const handleEPRFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMsg("❌ EPR file size must be ≤ 2MB");
      return;
    }
    onSelectValue("epr_doc", selectedFile);
    setErrorMsg("");
  };

  const handleFSSAIFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMsg("❌ FSSAI file size must be ≤ 2MB");
      return;
    }
    onSelectValue("fssai_doc", selectedFile);
    setErrorMsg("");
  };

  const createUpdateFactoryInfo = (e) => {
    e.preventDefault();
    setErrorMsg(null);

    let fileErrors = [];
    if (!uploadFormObj?.bis_cml_doc) {
      fileErrors.push("Please upload BIS CML document.");
    }
    if (!uploadFormObj?.epr_doc) {
      fileErrors.push("Please upload EPR document.");
    }
    if (!uploadFormObj?.fssai_doc) {
      fileErrors.push("Please upload FSSAI document.");
    }
    if (!uploadFormObj?.bis_cml_renewal_date) {
      fileErrors.push("Please enter BIS CML Renewal Date");
    }
    if (!uploadFormObj?.epr_renewal_date) {
      fileErrors.push("Please enter EPR Renewal Date");
    }
    if (!uploadFormObj?.fssai_renewal_date) {
      fileErrors.push("Please enter FSSAI Renewal Date");
    }

    if (fileErrors.length > 0) {
      setErrorMsg(fileErrors);
      return;
    }

    if (
      !isEmpty(uploadFormObj) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "operation") &&
      !isEmpty(uploadFormObj.operation) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "product_capacity") &&
      !isEmpty(uploadFormObj.product_capacity) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "variant") &&
      !isEmpty(uploadFormObj.variant) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "bis_cml_no") &&
      !isEmpty(uploadFormObj.bis_cml_no) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "packing") &&
      !isEmpty(uploadFormObj.packing) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "epr_no") &&
      !isEmpty(uploadFormObj.epr_no) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "packing_size") &&
      !isEmpty(uploadFormObj.packing_size) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "fsaai_no") &&
      !isEmpty(uploadFormObj.fsaai_no) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "water_source") &&
      !isEmpty(uploadFormObj.water_source)
    ) {
      setLoading(true);
      postUserFactoryInfo(userId, uploadFormObj, dispatch)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
            setIsUpdateMode(false);
            setIsCreateMode(false);
            callGetUserFactoryInfoAPI(userId, dispatch);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setErrorMsg("Please enter the mandatory fields.");
    }
  };

  const factoryInfoForm = () => {
    return (
      <Row className="m-0 form-row ">
        <Row className="m-0 px-0 w-full px-0 mb-4 title-button-row">
          <Col md={6} xs={6} className="m-0 p-0">
            <h2>{!isUpdateMode ? "ADD Factory Info" : "Update Factory Info"}</h2>
          </Col>
          <Col md={6} xs={6} className="m-0 p-0 text-end">
            {factoryInfo?.data !== null && (
              <Button
                className="btn-theme"
                size="sm"
                onClick={() => {
                  setIsCreateMode(false);
                  setIsUpdateMode(false);
                }}
              >
                <i className="bi bi-eye"></i> {"View"}
              </Button>
            )}
          </Col>
        </Row>
        <Form className="my-2 modal-custom-class" onSubmit={createUpdateFactoryInfo}>
          <Row className="m-0 ">
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Operation"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <CustomSelectDropdown
                  style={{
                    chips: {
                      margin: 0,
                    },
                    multiselectContainer: {
                      backgroundColor: "#f8f8f8",
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={[{ name: "Semi" }, { name: "Full Auto" }]}
                  onSelect={(e) => onSelectValue("operation", e[0].name)}
                  selectedValues={
                    Object.prototype.hasOwnProperty.call(uploadFormObj, "operation")
                      ? [{ name: uploadFormObj?.operation }]
                      : []
                  }
                  displayValue={"name"}
                  // disable={isUpdateMode ? true : false}
                  singleSelect
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Product Capacity"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <CustomSelectDropdown
                  style={{
                    chips: {
                      margin: 0,
                    },
                    multiselectContainer: {
                      backgroundColor: "#f8f8f8",
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={[
                    { name: "40 BPM" },
                    { name: "60 BPM" },
                    { name: "90 BPM" },
                    { name: "120 BPM" },
                  ]}
                  onSelect={(e) => onSelectValue("product_capacity", e[0].name)}
                  selectedValues={
                    Object.prototype.hasOwnProperty.call(uploadFormObj, "product_capacity")
                      ? [{ name: uploadFormObj?.product_capacity }]
                      : []
                  }
                  displayValue={"name"}
                  // disable={isUpdateMode ? true : false}
                  singleSelect
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Variant"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <CustomSelectDropdown
                  style={{
                    multiselectContainer: { backgroundColor: "#f8f8f8" },
                    chips: {
                      background: "#fbb040",
                      margin: "0 2px",
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={[
                    { name: "250 ML" },
                    { name: "500 ML" },
                    { name: "750 ML" },
                    { name: "1 LTR" },
                    { name: "2 LTR" },
                    { name: "5 LTR" },
                    { name: "10 LTR" },
                    { name: "20 LTR" },
                  ]}
                  onSelect={(selectedList) =>
                    onSelectValue("variant", selectedList.map((item) => item.name).join(","))
                  }
                  onRemove={(selectedList) =>
                    onSelectValue("variant", selectedList.map((item) => item.name).join(","))
                  }
                  selectedValues={
                    uploadFormObj?.variant
                      ? uploadFormObj.variant.split(",").map((v) => ({ name: v }))
                      : []
                  }
                  displayValue="name"
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Packing"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <CustomSelectDropdown
                  style={{
                    chips: {
                      margin: 0,
                    },
                    multiselectContainer: {
                      backgroundColor: "#f8f8f8",
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={[{ name: "Box" }, { name: "Shink" }, { name: "Both" }]}
                  onSelect={(e) => onSelectValue("packing", e[0].name)}
                  selectedValues={
                    Object.prototype.hasOwnProperty.call(uploadFormObj, "packing")
                      ? [{ name: uploadFormObj?.packing }]
                      : []
                  }
                  displayValue={"name"}
                  // disable={isUpdateMode ? true : false}
                  singleSelect
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Packing Size"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <CustomSelectDropdown
                  style={{
                    chips: {
                      margin: 0,
                    },
                    multiselectContainer: {
                      backgroundColor: "#f8f8f8",
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={[
                    { name: "12" },
                    { name: "15" },
                    { name: "6" },
                    { name: "24" },
                    { name: "40" },
                    { name: "48" },
                  ]}
                  onSelect={(e) => onSelectValue("packing_size", e[0].name)}
                  selectedValues={
                    Object.prototype.hasOwnProperty.call(uploadFormObj, "packing_size")
                      ? [{ name: uploadFormObj?.packing_size }]
                      : []
                  }
                  displayValue={"name"}
                  // disable={isUpdateMode ? true : false}
                  singleSelect
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Row Water Source"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <CustomSelectDropdown
                  style={{
                    chips: {
                      margin: 0,
                    },
                    multiselectContainer: {
                      backgroundColor: "#f8f8f8",
                    },
                    option: {
                      background: "#fbb040",
                      color: "#FFFFFF",
                      borderBottom: "1px solid #FFFFFF",
                    },
                  }}
                  options={[{ name: "Well" }, { name: "Bore well" }, { name: "Other" }]}
                  onSelect={(e) => onSelectValue("water_source", e[0].name)}
                  selectedValues={
                    Object.prototype.hasOwnProperty.call(uploadFormObj, "water_source")
                      ? [{ name: uploadFormObj?.water_source }]
                      : []
                  }
                  displayValue={"name"}
                  // disable={isUpdateMode ? true : false}
                  singleSelect
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={3}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"BIS CML No."}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.bis_cml_no}
                  onChange={(e) => onSelectValue("bis_cml_no", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={3}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"BIS CML Renewal Date"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  required
                  value={uploadFormObj?.bis_cml_renewal_date}
                  onChange={(e) => onSelectValue("bis_cml_renewal_date", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>
                  Upload BIS CML Document (PNG/JPG/PDF ≤ 2MB)
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={handleBISFileChange}
                  className="custom-file-input"
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={3}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"EPR No."}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.epr_no}
                  required
                  onChange={(e) => onSelectValue("epr_no", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={3}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"EPR Renewal Date"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={uploadFormObj?.epr_renewal_date}
                  required
                  onChange={(e) => onSelectValue("epr_renewal_date", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>
                  Upload EPR Document (PNG/JPG/PDF ≤ 2MB)
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={handleEPRFileChange}
                  className="custom-file-input"
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={3}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"FSSAI NO."}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.fsaai_no}
                  onChange={(e) => onSelectValue("fsaai_no", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={3}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"FSSAI Renewal Date"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  required
                  value={uploadFormObj?.fssai_renewal_date}
                  onChange={(e) => onSelectValue("fssai_renewal_date", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>
                  Upload FSSAI Document (PNG/JPG/PDF ≤ 2MB)
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={handleFSSAIFileChange}
                  className="custom-file-input"
                />
              </Form.Group>
            </Col>
          </Row>

          {(() => {
            if (Array.isArray(errorMsg) && errorMsg.length > 0) {
              return (
                <Row className="m-0 p-0">
                  <Col md={12}>
                    <ul className="m-0 p-0 mx-2 list-unstyled">
                      {errorMsg.map((msg, i) => (
                        <li key={i} className="d-flex align-items-start text-danger">
                          <span className="me-2 text-danger">✖</span>
                          <span>{msg}</span>
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              );
            } else {
              return (
                <Row className="m-0 p-0">
                  <Col md={12}>
                    <p className="error-msg">{errorMsg}</p>
                  </Col>
                </Row>
              );
            }
          })()}

          <div className="action-buttons">
            {factoryInfo?.data !== null && (
              <CustomButton
                buttonClasses="close-btn"
                onClick={() => {
                  setIsCreateMode(false);
                  setIsUpdateMode(false);
                }}
                disabled={requestCall?.loading}
              >
                <i className="bi bi-x-lg"></i> {"Close"}
              </CustomButton>
            )}

            <CustomButton
              variant="primary"
              buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
              type="submit"
              loading={requestCall?.loading}
            >
              <i className="bi bi-floppy"></i> {!isUpdateMode ? "Add" : "update"}
            </CustomButton>
          </div>
        </Form>
      </Row>
    );
  };

  const factoryInfoView = () => {
    return (
      <Row className="factoryInfo m-0 ">
        <Row className="heading-div">
          <Col md={6} xs={6} className="m-0 p-0">
            <h5 className="text-uppercase p-0 m-0">Factory Details</h5>
          </Col>
          <Col md={6} xs={6} className="m-0 p-0 text-end">
            <Button
              className="btn-theme"
              size="sm"
              onClick={() => {
                setIsUpdateMode(true);
              }}
            >
              <i className="bi bi-pencil"></i> Edit
            </Button>
          </Col>
        </Row>
        <hr />
        <Row className="m-0 p-0">
          <Col xs={6} md={6} lg={6} className="p-0">
            <Row className="m-0 p-0">
              <Col md={12}>
                <p>
                  <span>{"Operation:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.operation}</span>
                </p>
                <p>
                  <span>{"Variants:"}</span>
                  <span className=" bold-span">
                    {" "}
                    {factoryInfo?.data?.variant?.split(",").join(", ")}
                  </span>
                </p>
                <p>
                  <span>{"Packing:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.packing}</span>
                </p>
                <p>
                  <span>{"Packing Size:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.packing_size}</span>
                </p>
                <p>
                  <span>{"Product Capacity:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.product_capacity}</span>
                </p>
                <p>
                  <span>{"Row Water Source:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.water_source}</span>
                </p>
              </Col>
            </Row>
          </Col>
          <Col xs={6} md={6} lg={6} className="p-0">
            <Row className="m-0 p-0">
              <Col md={12}>
                <p>
                  <span>{"BIS CML No:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.bis_cml_no}</span>
                  {isEmpty(factoryInfo?.data?.bis_cml_doc) ? (
                    <span className="m-0 p-0 small text-danger mx-2">
                      * Please upload BIS CML document
                    </span>
                  ) : (
                    <a
                      href={factoryInfo?.data?.bis_cml_doc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="bi bi-download mx-2 text-primary"></i>
                    </a>
                  )}
                </p>
                <p>
                  <span>{"BIS CML Renewal Date:"}</span>
                  <span className=" bold-span">
                    {" "}
                    {!isEmpty(factoryInfo?.data?.bis_cml_renewal_date)
                      ? TimestampConverter(factoryInfo?.data?.bis_cml_renewal_date, true)
                      : ""}
                  </span>
                  {isEmpty(factoryInfo?.data?.bis_cml_renewal_date) && (
                    <span className="m-0 p-0 small text-danger mx-2">
                      * Please add BIS CML Renewal date
                    </span>
                  )}
                </p>

                <p>
                  <span>{"EPR No:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.epr_no}</span>
                  {isEmpty(factoryInfo?.data?.epr_doc) ? (
                    <span className="m-0 p-0 small text-danger mx-2">
                      * Please upload EPR document
                    </span>
                  ) : (
                    <a href={factoryInfo?.data?.epr_doc} target="_blank" rel="noopener noreferrer">
                      <i className="bi bi-download mx-2 text-primary"></i>
                    </a>
                  )}
                </p>
                <p>
                  <span>{"EPR Renewal Date:"}</span>
                  <span className=" bold-span">
                    {" "}
                    {!isEmpty(factoryInfo?.data.epr_renewal_date)
                      ? TimestampConverter(factoryInfo?.data.epr_renewal_date, true)
                      : ""}
                  </span>
                  {isEmpty(factoryInfo?.data?.epr_renewal_date) && (
                    <span className="m-0 p-0 small text-danger mx-2">
                      * Please add EPR Renewal date
                    </span>
                  )}
                </p>

                <p>
                  <span>{"FSSAI No:"}</span>
                  <span className=" bold-span"> {factoryInfo?.data.fsaai_no}</span>
                  {isEmpty(factoryInfo?.data?.fssai_doc) ? (
                    <span className="m-0 p-0 small text-danger mx-2">
                      * Please upload FSSAI document
                    </span>
                  ) : (
                    <a
                      href={factoryInfo?.data?.fssai_doc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="bi bi-download mx-2 text-primary"></i>
                    </a>
                  )}
                </p>
                <p>
                  <span>{"FSSAI Renewal Date:"}</span>
                  <span className=" bold-span">
                    {" "}
                    {!isEmpty(factoryInfo?.data.fssai_renewal_date)
                      ? TimestampConverter(factoryInfo?.data.fssai_renewal_date, true)
                      : ""}
                  </span>
                  {isEmpty(factoryInfo?.data?.fssai_renewal_date) && (
                    <span className="m-0 p-0 small text-danger mx-2">
                      * Please add FSSAI Renewal date
                    </span>
                  )}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
    );
  };

  return (
    <>
      {DialogModal}
      {loading && <PageSpinner />}
      <div className="p-0 company-info-container">
        {(() => {
          if (!isEmpty(factoryInfo?.data)) {
            if (!isUpdateMode) {
              return factoryInfoView();
            } else {
              return factoryInfoForm();
            }
          }
        })()}
      </div>
    </>
  );
};

export default UserFactoryInfo;
